import { observer } from 'mobx-react-lite';
import NavigationTabs from './BaseComponents/OrderServices/NavigationTabs';
import Search from './BaseComponents/OrderServices/Search';
import { Outlet, useLocation } from 'react-router-dom';
import Sort from './BaseComponents/OrderServices/Sort';
// import Filters from './BaseComponents/OrderServices/Filters';
import LocalNav from './BaseComponents/OrderServices/LocalNav';
import { useCartContext } from './CartProvider';
import { AnimatePresence, motion } from 'framer-motion';
import ResumeOrderBreadcrumbs from './BaseComponents/OrderServices/ResumeOrderBreadcrumbs';
import SyncLoading from './BaseComponents/OrderServices/SyncLoading';

const OrderServices = observer(() => {
  const { pathname } = useLocation();
  const cart = useCartContext();

  const isAccessServicePage = pathname.includes('/order-services/access');
  const isMobilityServicePage = pathname.includes('/order-services/mobility');

  return (
    <div className="relative my-0 flex flex-1 grow flex-col p-4 pb-8 sm:px-8 sm:pt-8">
      <ResumeOrderBreadcrumbs />
      <div className="mb-6 flex items-center justify-between gap-4">
        <h1 className="text-4xl font-bold leading-9 text-content-base-default">
          Order services
        </h1>
        <SyncLoading />
      </div>
      <div className="">
        <div className="flex flex-col justify-between gap-4 lg:flex-row lg:gap-0">
          <div className="flex-1">
            <NavigationTabs />
            <div className="-mt-[1px] flex border-b border-stroke-base-subdued lg:hidden" />
          </div>
          <div className="mb-4 flex flex-col-reverse items-end gap-6 xs:flex-row xs:self-end">
            <>
              <div className="flex gap-2 self-start xs:self-end">
                {/* commented for now */}
                {/* <Filters /> */}
                <Sort />
              </div>
              <Search />
            </>
          </div>
        </div>
        <div className="-mt-[1px]  flex border-b border-stroke-base-subdued" />
      </div>
      {isMobilityServicePage && (
        <div className="border-b border-stroke-base-subdued py-4 transition-all duration-700">
          <LocalNav />
        </div>
      )}
      <Outlet />
      <AnimatePresence>
        {!!cart.isOpen &&
          isAccessServicePage &&
          cart.cartState === 'locations' && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="absolute inset-0 z-10 h-full w-full cursor-pointer bg-background-base-surface-1/50"
              onClick={() => cart.close()}
            />
          )}
      </AnimatePresence>
    </div>
  );
});

export default OrderServices;
